<template>
  <button
    class="icon-button"
    :data-style="styling"
    :disabled="disabled"
    :data-variant="variant"
  >
    <span class="visually-hidden"> <slot></slot>> </span>
    <Icon :icon="icon"></Icon>
  </button>
</template>

<script>
import Icon from "./Icon.vue";
export default {
  components: {
    Icon,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    styling: {
      type: String,
      required: false,
      default: "",
    },
    variant: {
      type: String,
      required: false,
      default: "",
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup() {},
};
</script>

<style lang="scss">
// Coloring exceptions
@mixin icon-button-coloring {
  &[data-style="light"] {
    --icon-button-background-color: var(--color-shade-white);
    --icon-button-color: var(--color-primary);

    &:hover,
    &:focus,
    &:active {
      --icon-button-background-color: var(--color-shade-light);
    }
  }
}

// Variants exceptions
@mixin icon-button-variants {
  &[data-variant="outline"] {
    --icon-button-color: var(--icon-button-background-color);
    --icon-button-border-color: var(--icon-button-background-color);
    --outline-offset: 2px; // Outline offset for :focus styles
    background: transparent;
  }

  &[data-variant="clear"] {
    --icon-button-color: var(--icon-button-background-color);
    --outline-offset: 2px; // Outline offset for :focus styles
    border-color: transparent;
    background: transparent;
  }
}

.icon-button {
  --icon-button-background-color: var(--color-shade-dark);
  --icon-button-color: var(--color-shade-light);
  --icon-button-border-color: transparent;

  display: inline-block;
  background: var(--icon-button-background-color);
  border: var(--border-thin) solid var(--icon-button-border-color);
  padding: 0.8em;
  font-size: var(--size--3);
  color: var(--icon-button-color);
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  border-radius: 50%;

  svg {
    display: block;
    width: 1em;
    height: 1em;
  }

  // Disabled buttons
  &[disabled] {
    pointer-events: none;
    opacity: 0.5;
  }

  &:hover svg {
    filter: invert(0.2);
  }

  @include icon-button-coloring;

  @include icon-button-variants;
}
</style>
